import { useCallback } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

import Grid from "@mui/material/Grid";
import { useFormWithNotification } from "@covertree/hooks";
import { FormTextField } from "@covertree/ui";

import { useAppDispatch } from "@redux/hooks";
import { submitClaimDetails } from "@redux/slices";
import { LossType } from "@api/operations.generated";
import { StepPath } from "@routing/paths";
import { useGetClaimDetailsForLossType } from "@hooks/useGetClaimDetailsForLossType";

import { InjuredPersonsSection } from "../shared/InjuredPersonsSection";
import { ClaimsForm } from "../../ClaimsForm";
import { OtherForm, validation } from "./form";

export const Other = () => {
  const dispatch = useAppDispatch();

  const defaultValues = useGetClaimDetailsForLossType();

  const form = useFormWithNotification({
    mode: "all",
    reValidateMode: "onSubmit",
    defaultValues,
    resolver: yupResolver(validation),
  });

  const { control } = form;

  const submit = useCallback((value: OtherForm) => {
    dispatch(
      submitClaimDetails({
        value,
        type: LossType.Other,
      })
    );
  }, []);

  return (
    <ClaimsForm
      form={form}
      onSubmit={submit}
      navigateToStep={StepPath.UPLOAD_CLAIM_DOCUMENTS}
      dataTestId="other">
      <Grid item xs={12}>
        <FormTextField
          id="claim-description"
          dataTestId="claim-description"
          name="claimDescription"
          multiline
          rows={4}
          label="Please provide a description of the loss and how it happened?"
          control={control}
        />
      </Grid>
      <Grid item xs={12}>
        <InjuredPersonsSection />
      </Grid>
    </ClaimsForm>
  );
};
